import {connect} from 'react-redux';
import {CollapsibleLinkpile} from '@homeaway/react-linkpile';

import './styles.less';

const mapStateToProps = (state) => ({
    ...state.seoLinkpile,
    isMobile: state.config.isMobile,
    site: state.config.site.name
});

export default connect(mapStateToProps)(CollapsibleLinkpile);
